 <template>
  <div id="Ceshi">
    Ceshi
  </div>
</template>

<script>

export default {
  name: "Ceshi",
  // 模板引入
  components: {},
  // 数据
  data() {
    return {};
  },
  // 方法
  methods: {

  },
  // 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 更新后
  updated() {},
};
</script>

<style lang="less" scoped>
</style> 